import ButtonsOnBreakState from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/Buttons/ButtonsOnBreakState';
import ButtonsOnClockInState from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/Buttons/ButtonsOnClockInState';
import { useClockedInViewContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/ClockedInViewProvider/ClockedInViewProvider';
import { APP_STATE_ON_BREAK } from '@kiosk/constants';

type Props = { shortenAnimations: boolean };

const Buttons = ({ shortenAnimations }: Props) => {
  const { appState } = useClockedInViewContext();

  const onBreak = appState === APP_STATE_ON_BREAK;

  return (
    <>
      {onBreak && <ButtonsOnBreakState shortenAnimations={shortenAnimations} />}
      {!onBreak && <ButtonsOnClockInState shortenAnimations={shortenAnimations} />}
    </>
  );
};

export default Buttons;
